export const PREFIX = 'pm-admin-';
export const TOKENINFO = 'token';
export const OSSPREFIX = 'pm-admin';
export const WHITE_ROLES = ['/home', '/system'];
